import axios, { type AxiosError, type CreateAxiosDefaults } from 'axios';
import { toast } from 'react-toastify';

import { ToastNotification } from '@/components';
import { AXIOS_ERROR_TOAST } from '@/constants';

export function createApiClient(
  serviceConfig: CreateAxiosDefaults,
  overrideConfig = false,
) {
  const apiClient = axios.create({
    ...serviceConfig,
    headers: {
      'Content-Type': 'application/json',
      ...serviceConfig.headers,
    },
    ...(overrideConfig ? serviceConfig : {}),
  });

  // setting response error handling
  apiClient.interceptors.response.use(undefined, (error: AxiosError) => {
    if (error.response) {
      const { status } = error.response;

      switch (status) {
        case 401:
          toast(
            <ToastNotification
              type="error"
              title="Unauthorized! Redirecting to login..."
            />,
            {
              toastId: AXIOS_ERROR_TOAST,
            },
          );
          console.error('Unauthorized:', error);
          break;

        case 500:
          toast(
            <ToastNotification type="error" title="Internal Server Error..." />,
            {
              toastId: AXIOS_ERROR_TOAST,
            },
          );
          console.error('Internal Server Error:', error);
          break;
        default:
          toast(
            <ToastNotification type="error" title="Unexpected error..." />,
            {
              toastId: AXIOS_ERROR_TOAST,
            },
          );
          console.error('Unexpected error:', error);
      }
    }

    return Promise.reject(error);
  });

  return apiClient;
}
